import "./Home.css";

export default function Home() {
    return (
        <div className="pageContainer" id="homePageContainer">
            <div id="name">ANNA RENO</div>
            <div className="pageSubTitle">Full-Stack Developer. &nbsp; Project Manager. &nbsp; Problem Solver.</div>
        </div>
    
        )
}